var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-2",attrs:{"light":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Dashboard")])],1),_c('DashboardList',{attrs:{"items":_vm.itemsList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }